export default __webpack_public_path__ + "static/media/ai.df6e3d7e.jpg";